import { getDate } from "../utils";


export const tweet = {
    name: "Hidayt Rahman",
    username: "@hidaytrahman",
    photo: "https://pbs.twimg.com/profile_images/1080078041533927424/1WDi-9lG_200x200.jpg",
    profile: {
        avatar: "https://cdn4.iconfinder.com/data/icons/social-media-icons-the-circle-set/48/twitter_circle-512.png"
    },
    post: {
        text: `Please be nice to people in service jobs. They work long hours and are treated like garbage by people, like the person
        who tried using the "barista" title in a demeaning way.`,
        device: "Twitter for iPhone",
        time: "3:30 PM",
        date: getDate() //"June 29, 2021"
    }

};